import React, { useCallback } from 'react'

import { Box, Checkbox } from '@chakra-ui/react'
import { useField, useFormikContext } from 'formik'

/**
 * NewsletterSubscribedField - Formik-connected checkbox for newsletter subscription
 * @param {string} field - The form field name (default: 'newsletter_subscribed')
 */
const NewsletterSubscribedField = ({ field = 'newsletter_subscribed' }) => {
  const { setFieldValue } = useFormikContext()
  const [formikField] = useField(field)

  const handleChange = useCallback(
    e => setFieldValue(field, e.target.checked),
    [setFieldValue, field]
  )

  return (
    <Box mb={2}>
      <Checkbox
        id={`constituent-newsletter-subscribed-${field}`}
        isChecked={formikField.value}
        onChange={handleChange}
      >
        Subscribed to newsletter
      </Checkbox>
    </Box>
  )
}

export default NewsletterSubscribedField
